
import './App.css';
import TodoList from './Components/TodoList'
function App() {
  return (
    <div className="Todo-list-container">
      <TodoList />
      
    </div>
  );
}

export default App;
